"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const SvgIcon_1 = tslib_1.__importDefault(require("@mui/material/SvgIcon"));
const MenuNFCertWikiIcon = (
// Allows the callee to override the default values and pass any additional prop of SvgIcon. See https://material-ui.com/api/svg-icon/
{ titleAccess, fontSize = "small", ...rest }, forwardedRef) => (react_1.default.createElement(SvgIcon_1.default, { ...{ titleAccess, fontSize, ...rest, ref: forwardedRef, viewBox: "0 0 48 48" } },
    react_1.default.createElement("defs", { id: "defs3" },
        react_1.default.createElement("linearGradient", { id: "linearGradient3101" },
            react_1.default.createElement("stop", { id: "stop3103", offset: "0" }),
            react_1.default.createElement("stop", { id: "stop3105", style: { stopColor: "#000000", stopOpacity: 0 }, offset: "1" })),
        react_1.default.createElement("radialGradient", { cx: "17.3125", cy: "25.53125", r: "9.6875", fx: "17.3125", fy: "25.53125", id: "radialGradient3107", xlinkHref: "#linearGradient3101", gradientUnits: "userSpaceOnUse", gradientTransform: "matrix(1,0,0,0.351613,0,16.55413)" })),
    react_1.default.createElement("g", { id: "layer1" },
        react_1.default.createElement("path", { d: "M 27,25.53125 A 9.6875,3.40625 0 1 1 7.625,25.53125 A 9.6875,3.40625 0 1 1 27,25.53125 z", transform: "matrix(2.182912,0,0,2.182912,-13.50372,-14.35012)", id: "path3099", style: {
                opacity: 0.40909089,
                fill: "url(#radialGradient3107)",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "none",
                strokeWidth: 1.10533953,
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                marker: "none",
                markerStart: "none",
                markerMid: "none",
                markerEnd: "none",
                strokeMiterlimit: 4,
                strokeDasharray: "none",
                strokeDashoffset: 0,
                strokeOpacity: 1,
                visibility: "visible",
                display: "inline",
                overflow: "visible",
            } }),
        react_1.default.createElement("path", { d: "M 46.138718,23.42804 A 22.008699,21.213203 0 1 1 2.1213188,23.42804 A 22.008699,21.213203 0 1 1 46.138718,23.42804 z", transform: "matrix(0.94463,0,0,0.980053,1.504174,-1.556912)", id: "path1650", style: {
                opacity: 1,
                fill: "#888a85",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "#2e3436",
                strokeWidth: 0.98214942,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: 4,
                strokeDasharray: "none",
                strokeDashoffset: 0,
                strokeOpacity: 1,
            } }),
        react_1.default.createElement("path", { d: "M 46.138718,23.42804 A 22.008699,21.213203 0 1 1 2.1213188,23.42804 A 22.008699,21.213203 0 1 1 46.138718,23.42804 z", transform: "matrix(0.914086,0,0,0.948364,2.380576,-0.905815)", id: "path3392", style: {
                opacity: 1,
                fill: "none",
                fillOpacity: 1,
                fillRule: "nonzero",
                stroke: "#babdb6",
                strokeWidth: 0.98214942,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: 4,
                strokeDasharray: "none",
                strokeDashoffset: 0,
                strokeOpacity: 1,
            } }),
        react_1.default.createElement("path", { d: "M 43.676426,20.47678 C 43.676426,31.307396 37.624257,16.170581 25.001688,20.863168 C 12.279172,25.592912 4.4350535,31.307396 4.4350535,20.47678 C 4.4350535,9.6461627 13.22512,0.85609769 24.05574,0.85609769 C 34.886359,0.85609769 43.676426,9.6461627 43.676426,20.47678 z", id: "path3068", style: {
                fill: "#fffeff",
                fillOpacity: 0.21390375,
                fillRule: "nonzero",
                stroke: "none",
                strokeWidth: 1,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: 4,
                strokeDashoffset: 0,
                strokeOpacity: 1,
            } }),
        react_1.default.createElement("path", { d: "M 14.55583,17.441713 C 14.018634,16.538247 13.089648,15.645132 12.419226,15.38753 L 12.311107,15.345996 L 12.311107,14.910985 L 12.311107,14.475966 L 12.380244,14.466484 L 18.46862,14.457007 C 18.472205,14.622692 18.475686,14.967946 18.470889,15.291924 C 17.665739,15.392 16.695187,15.785526 16.96414,16.688082 C 18.499128,20.07954 19.895871,23.531957 21.411299,26.931968 L 24.012397,22.068162 C 23.005886,20.006496 22.272641,17.920897 21.170829,15.898265 C 20.811602,15.315824 19.840146,15.299579 19.152111,15.27706 L 19.154437,14.471917 L 24.909389,14.491734 L 24.92592,15.269239 C 24.407127,15.34094 23.795577,15.464223 23.864923,16.092964 L 25.498306,19.705421 C 26.035843,18.558708 26.633298,17.436309 27.107374,16.26102 C 27.322577,15.330471 26.275683,15.28419 25.608026,15.258283 L 25.596293,14.491728 L 30.738887,14.471917 L 30.738887,15.256122 C 29.987164,15.309261 29.276057,15.526072 28.861474,16.081836 C 27.853662,17.639801 27.106099,19.407647 26.321133,21.099857 C 27.09672,22.933899 27.905056,24.765412 28.697776,26.447064 L 33.080788,16.337119 C 32.785115,15.670704 32.11552,15.435305 31.458261,15.282834 L 31.424713,14.467235 L 36.285119,14.506379 L 36.285014,15.299381 C 36.06845,15.333062 35.861109,15.399842 35.660588,15.487337 C 35.280547,15.663729 34.921546,16.0138 34.680757,16.442833 L 28.639328,30.342769 L 27.626914,30.350609 L 24.752844,23.581584 L 21.264091,30.350097 L 20.216666,30.350219 C 18.178344,26.104406 16.703652,21.636425 14.55583,17.441713 z", id: "path1873", style: { fill: "#ffffff", fillOpacity: 1, stroke: "none", strokeOpacity: 1 } }))));
const IconWithRef = react_1.default.forwardRef(MenuNFCertWikiIcon);
if (process.env.NODE_ENV !== "production") {
    // @ts-ignore: Expose property used for testing
    IconWithRef.Naked = MenuNFCertWikiIcon;
}
exports.default = IconWithRef;
